import { Injectable } from "@angular/core";
import { Device } from '@capacitor/device';
import { BehaviorSubject, Observable } from "rxjs";
import { FacebookTracker } from "../marketing/facebook-tracker";

@Injectable({
    providedIn: "root",
})

export class UniqueIDService {
    private mfaDeviceIdSubject:BehaviorSubject<string>;
    
    constructor(
        private facebookTracker: FacebookTracker,
    ) {
    }

    /**
     * Date: January 26, 2023: refactored the getUniqueID function so that it depends on the tracking module.   If the IDFA is available,
     * then getUniqueID will use it, otherwise it falls back to the existing behaviour, to generate a random number (see uuidv4 implementation below).
     * @returns Promise<string>
     */
    async getUniqueID(): Promise<string> {
        let tracking_ids = await this.facebookTracker.getAdvertisingIDs();
        if (tracking_ids && tracking_ids.IDFA && (tracking_ids.IDFA.indexOf('0000-0000') === -1)) {
            return tracking_ids.IDFA
        } else {
            //get unique ID for android, iphone and web
            const id = await Device.getId();

            return id.identifier;
        }
    }

    async getSelectorID() {
        //get unique ID for android, iphone and web
        const id = await Device.getId();

        return id.identifier;
    }

    uuidv4(): string {
        if (!(crypto.randomUUID instanceof Function)) {
            let d = new Date().getTime(); //Timestamp
            let d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; //Time in microseconds since page-load or 0 if unsupported
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16;//random number between 0 and 16
                if (d > 0) {//Use timestamp until depleted
                    r = (d + r) % 16 | 0;
                    d = Math.floor(d / 16);
                } else {//Use microseconds since page-load if supported
                    r = (d2 + r) % 16 | 0;
                    d2 = Math.floor(d2 / 16);
                }
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
        }
        else {
            return crypto.randomUUID();
        }
    }

    setMFADeviceIdAsObservable(deviceId: string) {
        if (deviceId) {
          if(!this.mfaDeviceIdSubject) {
            this.mfaDeviceIdSubject = new BehaviorSubject(deviceId)
          }
          this.mfaDeviceIdSubject.next(deviceId);
        }
    }

    getMFADeviceIdObservable():Observable<string> {
      return this.mfaDeviceIdSubject && this.mfaDeviceIdSubject.asObservable();
    }

    setMFADeviceId(deviceId: string) {
        if (deviceId) {
            localStorage.setItem('mfa_device_id', deviceId)
        }
    }

    getMFADeviceId(): string {
        let deviceId = localStorage.getItem('mfa_device_id');
        return deviceId
    }

    removeMFADeviceId(): void {
        localStorage.removeItem('mfa_device_id')
    }
}
